export function buildSubscriptionGrant(form) {
  const clientId = String(form.clientId || '').trim();
  const reason = String(form.reason || '').trim();
  if (!clientId || !form.planId) throw new Error('Select a client and a plan.');
  if (!['FREE_TRIAL', 'FREE_SUBSCRIPTION'].includes(form.type)) throw new Error('Choose a valid grant type.');
  const durationDays = Number(form.durationDays);
  if (!Number.isInteger(durationDays) || durationDays < 1 || durationDays > 3650) throw new Error('Duration must be a whole number from 1 to 3,650 days.');
  if (!reason) throw new Error('Provide a reason for this grant.');
  return { clientId, planId: form.planId, type: form.type, durationDays, reason, autoRenew: false, expectedSubscriptionId: form.expectedSubscriptionId || null };
}
export function clientName(client) {
  return client.businessProfile?.basicInfo?.businessName || client.clientId;
}
export function grantExpiry(startDate, days) {
  return new Date(new Date(startDate).getTime() + days * 86400000).toISOString();
}

// MongoDB JSON may expose BSON values as Extended JSON or plain numbers.
export function planNumber(value) {
  const number = Number(value?.$numberDecimal ?? value?.$numberInt ?? value?.$numberLong ?? value);
  return Number.isFinite(number) ? number : null;
}
export function eligiblePlan(plan) {
  return Boolean(plan?.planId && plan?.active === true && String(plan.status).toLowerCase() === 'active');
}
export function planEntitlements(plan) {
  return {
    limits: Object.entries(plan?.limits || {}).map(([name,value])=>({name,value:planNumber(value)})),
    modules: Array.isArray(plan?.modules) ? plan.modules : [],
    capabilities: Array.isArray(plan?.capabilities) ? plan.capabilities : [],
    unavailableModules: Array.isArray(plan?.unavailableModules) ? plan.unavailableModules : [],
  };
}
